import { REGEX } from '../constants/regex';

export const isRoulettePromoCode = (promoCode: string): boolean => {
  const regex = new RegExp(REGEX.ROULETTE_PROMO_CODE);

  return regex.test(promoCode);
};
